import { useTranslation } from 'react-i18next';
import heroImage from 'assets/images/accounting/call-to-action.jpg';
import {
  CopyStack,
  SectionInner,
  SplitImage,
  SplitRow,
  WhiteSection,
} from '../../HostfullyAccountingMarketing.styles';
import ContactUsButton from '../../components/ContactUsButton';
import {
  HeroEyebrow,
  HeroHeading,
  HeroSubtitle,
  HeroTitle,
  HeroVisual,
} from './HeroSection.styles';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <WhiteSection data-testid="marketing-hero">
      <SectionInner>
        <SplitRow>
          <CopyStack>
            <HeroHeading>
              <HeroEyebrow>
                {t('pageHostfullyAccounting.marketing.title')}
              </HeroEyebrow>
              <HeroTitle>
                {t('pageHostfullyAccounting.marketing.hero.headline')}
              </HeroTitle>
            </HeroHeading>
            <HeroSubtitle>
              {t('pageHostfullyAccounting.marketing.hero.description')}
            </HeroSubtitle>
            <ContactUsButton testId="marketing-contact-us-hero" />
          </CopyStack>
          <HeroVisual>
            <SplitImage
              src={heroImage}
              alt={t('pageHostfullyAccounting.marketing.hero.imageAlt')}
            />
          </HeroVisual>
        </SplitRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default HeroSection;
